export default "__VITE_ASSET__BPnAl4h1__"